import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface BrowserCompatibilityNoticeDialogData {
    showBrowserWarning: boolean;
    showResolutionWarning: boolean;
}

@Component({
    selector: 'app-browser-compatibility-notice',
    templateUrl: './browser-compatibility-notice.component.html',
    styleUrls: ['./browser-compatibility-notice.component.scss'],
    standalone: false,
})
export class BrowserCompatibilityNoticeComponent {
    constructor(
        private dialogRef: MatDialogRef<BrowserCompatibilityNoticeComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: BrowserCompatibilityNoticeDialogData
    ) {
        this.dialogRef.disableClose = true;
        //adds css class for styling in global styles
        this.dialogRef.addPanelClass('tryb-confirmation-dialog');
    }

    onClose(): void {
        this.dialogRef.close();
    }
}
